<script setup lang="ts">
import GoldFrame from "@/components/Common/GoldFrame.vue";
import CardInfo from "@/components/RegistrationPage/Card/PcVersion/CardInfo.vue";
import CardBackground from "@/components/RegistrationPage/Card/PcVersion/CardBackground.vue";
import ToolTipStandartDescription from "@/components/Common/tooltip/ToolTipStandartDescription.vue";
import ToolTipWrapper from "@/components/Common/tooltip/ToolTipWrapper.vue";
</script>

<script lang="ts">
import {defineComponent, PropType} from 'vue'
import store from "@/store";
import {PassProperties} from "@/components/RegistrationPage/Card/PassProperties";

export default defineComponent({
    name: 'WhitePassCard',

    data(): {
        tilt: {
            x: number
            y: number
        },

        targetTilt: {
            x: number
            y: number
        },

        scale: number

        interval: number | null

        lineHighlightInverval: number | null
        lines: number
        highlightedLineIndex: number
    } {
        return {
            tilt: {
                x: 0,
                y: 0,
            },

            targetTilt: {
                x: 0,
                y: 0,
            },

            scale: 1.24,
            interval: null,

            lineHighlightInverval: null as unknown as number | null,
            lines: 6,
            highlightedLineIndex: 0,
        }
    },

    props: {
        tiltAngle: {
            type: Number,
            default: 20,
        },

        pass: {
            type: Object as PropType<PassProperties>,
            required: true,
        },
    },

    methods: {
        onMouseMove(event: MouseEvent): void
        {
            if (this.pageWidth <= store.state.mobileVersionThresholdWidth) return

            const box = this.$refs.box
            if (box instanceof HTMLDivElement) {
                this.targetTilt.x = this.tiltAngle * ( 2 * event.offsetX / box.clientWidth - 1)
                this.targetTilt.y = - this.tiltAngle * ( 2 * event.offsetY / box.clientHeight - 1)
            }
        },

        onMouseLeave(): void
        {
            if (this.pageWidth <= store.state.mobileVersionThresholdWidth) return

            this.targetTilt.x = 0
            this.targetTilt.y = 0
        },

        onClick(): void
        {
            store.state.selectedPass = this.pass
        },

        createInterval(): void
        {
            this.scale = 1
            if (this.interval) {
                this.tilt.x = 0
                this.tilt.y = 0

                clearInterval(this.interval)
            }

            if (this.pageWidth <= store.state.mobileVersionThresholdWidth) return

            this.scale = 1.25
            this.interval = setInterval(() => {
                const deltaX = Math.abs(this.targetTilt.x - this.tilt.x)
                if (deltaX < 0.001) {
                    this.tilt.x = this.targetTilt.x
                } else {
                    this.tilt.x += (this.targetTilt.x - this.tilt.x) / 50
                }

                const deltaY = Math.abs(this.targetTilt.y - this.tilt.y)
                if (deltaY < 0.001) {
                    this.tilt.y = this.targetTilt.y
                } else {
                    this.tilt.y += (this.targetTilt.y - this.tilt.y) / 50
                }
            })
        },

        stopHighlight(): void
        {
            if (this.lineHighlightInverval) {
                clearInterval(this.lineHighlightInverval)

                this.lineHighlightInverval = null
            }
        },
        
        startHighlight(): void
        {
            this.stopHighlight()

            this.lineHighlightInverval = setInterval(
                () => {
                    this.highlightedLineIndex++

                    if (this.highlightedLineIndex > this.lines) {
                        this.highlightedLineIndex = 0
                    }
                },
                1000,
            )
        },
        
    },

    mounted(): void
    {
        this.createInterval()

        this.startHighlight()
    },

    unmounted() {
        this.stopHighlight()
    },

    computed: {
        pageWidth(): number
        {
            return store.state.pageSize.width
        },
    },
})
</script>

<template>
    <div class="pass-wrapper">
        <img class="noselect white_bg" draggable="false" :src="`/img/page/landing/registration/pass/white_pass/white_bg.png`"/>
        <img class="noselect ship" draggable="false" :src="`/img/page/landing/registration/pass/white_pass/ship.png`"/>

        <div class="pass-description">
            <ul>
                <li 
                    :class="{active: highlightedLineIndex === 1 && lineHighlightInverval !== null}"
                    @mousemove="stopHighlight"
                    @mouseleave="startHighlight"
                >
                    <ToolTipWrapper>
                        <template v-slot:component>
                            Анимированная голограмма корабля
                        </template>
                        <template v-slot:tooltip>
                            <ToolTipStandartDescription>
                                <div class="d-flex flex-column gap-1 fs-rem-10">
                                    <span>Пропуск «Элита Федерации» - единственный пропуск, включающий обалденную анимированную голограмму корпуса <span class="text-wheat font-furore">«Альфа»</span></span>
                                </div>
                            </ToolTipStandartDescription>
                        </template>
                    </ToolTipWrapper>
                </li>

                <li 
                    :class="{active: highlightedLineIndex === 2 && lineHighlightInverval !== null}"
                    @mousemove="stopHighlight"
                    @mouseleave="startHighlight"
                >
                    <ToolTipWrapper>
                        <template v-slot:component>
                            Самое большое число галакоинов
                        </template>
                        <template v-slot:tooltip>
                            <ToolTipStandartDescription>
                                <div class="d-flex flex-column gap-1 fs-rem-10">
                                    <span>Пропуск включает колоссальное количество внутриигровой донатной валюты!</span>
                                </div>
                            </ToolTipStandartDescription>
                        </template>
                    </ToolTipWrapper>
                </li>

                <li 
                    :class="{active: highlightedLineIndex === 3 && lineHighlightInverval !== null}"
                    @mousemove="stopHighlight"
                    @mouseleave="startHighlight"
                >
                    <ToolTipWrapper>
                        <template v-slot:component>
                            Стильная кастомизация профиля
                        </template>
                        <template v-slot:tooltip>
                            <ToolTipStandartDescription>
                                <div class="d-flex flex-column gap-1 fs-rem-10">
                                    <span>Аватарка и рамка из этого пропуска - настоящие произведения искусства!</span>
                                </div>
                            </ToolTipStandartDescription>
                        </template>
                    </ToolTipWrapper>
                </li>

                <li 
                    :class="{active: highlightedLineIndex === 4 && lineHighlightInverval !== null}"
                    @mousemove="stopHighlight"
                    @mouseleave="startHighlight"
                >
                    <ToolTipWrapper>
                        <template v-slot:component>
                            Бонусы всех других пропусков
                        </template>
                        <template v-slot:tooltip>
                            <ToolTipStandartDescription>
                                <div class="d-flex flex-column gap-1 fs-rem-10">
                                    <span>Пропуск <span class="text-wheat font-furore">«Элита Федерации»</span> включает в себя бонусы из всех других пропусков: аватарки, рамки, голограммы корпусов и дополнительные шмотки</span>
                                </div>
                            </ToolTipStandartDescription>
                        </template>
                    </ToolTipWrapper>
                </li>

                <li 
                    :class="{active: highlightedLineIndex === 5 && lineHighlightInverval !== null}"
                    @mousemove="stopHighlight"
                    @mouseleave="startHighlight"
                >
                    <ToolTipWrapper>
                        <template v-slot:component>
                            Вечные подписки на бусты
                        </template>
                        <template v-slot:tooltip>
                            <ToolTipStandartDescription>
                                <div class="d-flex flex-column gap-1 fs-rem-10">
                                    <span>Все возможные <span class="text-wheat font-furore">вечные предактивированные бусты</span> - главная фича пропуска!</span>

                                    <span>Бусты - это ежемесячные подписки, помогающие в разных игровых аспектах. К счастью, тебе никогда не придётся задумываться о том, чтобы их покупать или вовремя продлевать. Ведь ты - счастливый обладатель всех доступных бустов, причём с неограниченным сроком действия!</span>
                                    <span>Набор включает бусты опыта, майнинга, зондирования, крафта, ремонта и все остальные бусты, доступные в игре.</span>
                                </div>
                            </ToolTipStandartDescription>
                        </template>
                    </ToolTipWrapper>
                </li>

                <li 
                    :class="{active: highlightedLineIndex === 6 && lineHighlightInverval !== null}"
                    @mousemove="stopHighlight"
                    @mouseleave="startHighlight"
                >
                    <ToolTipWrapper>
                        <template v-slot:component>
                            Артефакт «Катализатор»
                        </template>
                        <template v-slot:tooltip>
                            <ToolTipStandartDescription>
                                <div class="d-flex flex-column gap-1 fs-rem-10">
                                    <span><span class="text-wheat font-furore">Катализатор</span> - редкий артефакт, значительно облегчающий жизнь. Помещённый в топливный бак, катализатор постепенно увеличивает количество топлива. Проблема экстренной дозаправки никогда не застанет тебя врасплох!</span>
                                </div>
                            </ToolTipStandartDescription>
                        </template>
                    </ToolTipWrapper>
                </li>
            </ul>
        </div>

        <div
            class="passCard noselect"
            :class="{
                active: pass === store.state.selectedPass,
            }"
            @mousemove="onMouseMove"
            @mouseleave="onMouseLeave"
            @click="onClick"
            :ref="'box'"
            :style="{
                transform: `perspective(1000px) rotateY(${tilt.x}deg) rotateX(${tilt.y}deg)`,
            }"
        >
            <GoldFrame
                :offset="0"
                :size-modifier="0.5"
            />

            <img class="noselect stars" draggable="false" :src="`/img/page/landing/registration/pass/white_pass/stars.png`"/>
            <img
                class="face"
                alt=""
                :src="`/img/page/landing/registration/avatar/white_pass/body.png`"
            />

            <div class="content absolute-fill">
                <CardBackground
                    :tilt="tilt"
                    :tilt-angle="tiltAngle"
                    :pass="pass"
                    :bg-url="`white_pass_1.jpg`"
                />

                <CardInfo
                    :pass="pass"
                    style="font-family: Furore !important;"
                />
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
@keyframes wp-rotation {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}

.pass-wrapper {
    width: 100%;
    display: flex;
    justify-content: start;
    align-items: center;
    margin-top: 34px;
    margin-bottom: 34px;

    .white_bg {
        z-index: 0;
        position: absolute;
        left: 300px;
    }

    .ship {
        z-index: 0;
        position: absolute;
        right: -235px;
        scale: 1.1;
    }

    .pass-description {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 100;
        position: absolute;
        left: 375px;

        ul {
            text-align: left;
            list-style: none;
            margin: 0;
            padding-left: 5px;

            li {
                margin: 6px 0 6px 0;
                font-size: 20px;
                font-family: Furore;

                background: linear-gradient(70deg,
                    #272316 0%,
                    #4a3f2a 25%,
                    #1b1810 45%,
                    #3c3421 55%,
                    #322c1d 75%,
                    #4c402d 100%
                );
                -webkit-background-clip: text;
                background-clip: text;
                color: transparent;
                text-shadow: 0 2px 3px rgba(0,0,0,0.2);

                letter-spacing: 0.03rem;
                cursor: help;

                transition: all 0.1s ease;

                &.active {
                    background: linear-gradient(70deg,
                        #35301e 0%,
                        #605237 25%,
                        #302b1d 45%,
                        #50452b 55%,
                        #4a422b 75%,
                        #61523a 100%
                    );
                    -webkit-background-clip: text;
                    background-clip: text;
                    padding-left: 8px;
                }

                &:hover {
                    background: transparent;
                    color: wheat;
                    text-shadow: 0 2px 3px rgba(0,0,0,0.7);
                    padding-left: 15px;
                }

                &::marker {
                    color: #1b1810;
                }
            }
        }
    }

    .passCard {
        display: flex;
        position: relative;
        min-width: 352px;
        max-width: 352px;
        min-height: 460px;
        max-height: 460px;

        transition:
            scale 0.075s ease,
            height 0.1s ease,
            box-shadow 0.2s ease,
            background-color 0.1s ease,
                //z-index 0.2s ease,
            translate 0.1s ease;
        z-index: 500;
        cursor: pointer;
        border-radius: 12px;
        overflow: hidden;

        * {
            pointer-events: none;
        }

        .face {
            z-index: 500;
            position: absolute;
            width: 270px;
            bottom: 0;
            left: 0;
            border-bottom-left-radius: 20px;
        }

        img {
            &.stars {
                z-index: 100;
                position: absolute;
                left: -180px;
                top: -80px;
                width: 600px;
                height: 600px;
                animation: wp-rotation 20s infinite linear;
            }
        }

        &:hover {
            scale: v-bind('scale');
            //translate: 0 60px;
            //height: 500px;
            z-index: 1200;
            box-shadow: 0 0 15px 10px rgba(0, 0, 0, 0.7);
        }

        &.active {
            box-shadow: 0 0 13px 10px #dcb263;
        }
    }
}
</style>
